<template>
  <div class="celebrity-detail main-top-border main-bg">
    <div class="main-wrap">
      <nav-crumb class="crumb-pt"></nav-crumb>
      <div class="fl">
        <div class="info-card part">
          <div class="photo item">
            <el-image class="img" :src="$common.imgPath(celebrityInfo.celebrityImg)" :alt="celebrityInfo.celebrityName" lazy fit="cover"></el-image>
            <p class="follow" @click="setShopFollow()"><span style="vertical-align: middle;" v-text="isCollect?'取消收藏':'收藏'"></span><span class="icon" :class="isCollect?'collect-yellow-color':'collect-grey-color'"></span></p>
            <button type="button" class="add-wx"
                    v-clipboard:copy="celebrityInfo.wechat?celebrityInfo.wechat:' '"
                    v-clipboard:success="copySuccess"
                    v-clipboard:error="copyError">
              <i class="el-icon-chat-dot-round"></i>结识TA <br>
              <span class="tips">添加TA微信好友</span>
            </button>
          </div>
          <div class="card-info item">
            <div style="overflow: hidden;">
              <div class="name">{{celebrityInfo.celebrityName}}</div>
              <ul class="num-list">
                <!--<li>
                  <p><span class="num">{{goodsCount}}</span>件</p>
                  <span class="tit">全部拍品</span>
                </li>
                <li>
                  <p><span class="num">{{newsCount}}</span>篇</p>
                  <span class="tit">文章数</span>
                </li>-->
                <li>
                  <p><span class="num">{{keyCount}}</span>种</p>
                  <span class="tit">名花数</span>
                </li>
                <li>
                  <p><span class="num">{{celebrityInfo.collectNum}}</span>人</p>
                  <span class="tit">关注了TA</span>
                </li>
              </ul>
            </div>
            <p class="desc" v-html="celebrityInfo.celebrityDesc"></p>
            <p class="honor">{{celebrityInfo.celebrityBright}}</p>

          </div>

        </div>
        <div class="article">
          <el-tabs v-model="activeName" @tab-click="toggleTab" class="celebrity-tab">
            <el-tab-pane
                    v-for="item in articleTabs"
                    :key="item.name"
                    :label="item.title"
                    :name="item.name"
            >
              <article-item v-show="activeName=='new'" :newList="newList"></article-item>
              <article-item-new v-show="activeName=='essence'" :dynamicList="essenceList"></article-item-new>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="fr">
        <div class="part shop-info mb10">
          <div class="info-top">
            <el-image class="img" :src="$common.imgPath(celebrityInfo.headImg)" :alt="celebrityInfo.shopName" lazy fit="cover"></el-image>
            <div class="desc">
              <p class="name">{{celebrityInfo.shopName}}</p>
              <p>{{celebrityInfo.desc}}</p>
            </div>
          </div>
          <button type="button" class="btn-shop" @click="$router.push({path:`/shop/detail/${shopId}`})">进店逛逛</button>
        </div>
        <!--<div class="part celebrity mb10">-->
          <!--<h3 class="title">名人介绍</h3>-->
          <!--<div class="desc">-->
            <!--{{celebrityInfo.celebrityDesc}}-->
          <!--</div>-->
        <!--</div>-->
        <div class="part celebrity mb10">
          <h3 class="title">名人亮点</h3>
          <div class="desc">
            {{celebrityInfo.celebrityBright}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import navCrumb from '../../components/crumb/index'
    import articleItem from '../../components/article/celebrityArticleItem'
    import articleItemNew from '../../components/article/celebrityArticleItemNew'
    import {getShopInfoForUser,setShopFollow} from '../../api/shop'
    import {getNewsCelebrityPage} from '../../api/news'
    import {dynamicPageForShop} from '../../api/dynamic'
  export default {
        data(){
            return {
                celebrityInfo:{},//名人信息
                goodsCount:0,//全部拍品
                isCollect:false,//是否收藏
                newsCount:0,//文章数量
                keyCount:0,//名花数
                activeName:'new',//活动tab
                articleTabs:[
                    {
                        title:'撰写文章',
                        name:'new',
                        contList:[]
                    },
                    {
                        title:'最新动态',
                        name:'essence',
                        contList:[]
                    }
                ],//
                newList:[],//最新文章
                essenceList:[],//最新动态
                current:1,
                size:2
            }
        },
      components:{
          navCrumb,
          articleItem,
          articleItemNew
      },
      computed:{
            shopId(){
                return this.$route.params.id||0;
            }
      },
      created () {
      },
      mounted(){
          this.getCelebrityInfo();
          this.getNewsCelebrityPageList();
          this.getDynamicPageForShopList();
      },
      methods:{
          toggleTab(tab, event) {
              console.log(tab, event);
          },
          copySuccess(e){
              this.$message({
                  message:  '复制成功',
                  type: 'success'
              });
          },
          copyError(e){
              this.$message({
                  message:  '复制失败',
                  type: 'success'
              });
          },
          getCelebrityInfo(){
              getShopInfoForUser(this.shopId).then(res=>{
                  this.celebrityInfo=res.data.shop;
                  this.goodsCount=res.data.goodsCount;
                  this.newsCount=res.data.newsCount;
                  this.keyCount=res.data.keyCount;
                  this.isCollect=res.data.isCollect;
              })
          },
          getNewsCelebrityPageList(){
              getNewsCelebrityPage({
                  shopId:this.shopId,
                  current:this.current,
                  size:this.size
              }).then(res=>{
                  this.newList=res.data.records;
              })
          },
          getDynamicPageForShopList(){
              dynamicPageForShop({
                  shopId:this.shopId,
                  current:this.current,
                  size:this.size
              }).then(res=>{
                  this.essenceList=res.data.records;
              })
          },
          //操作关注/取消 店铺
          setShopFollow(){
              setShopFollow({
                  shopId:this.shopId
              }).then(res=>{
                  this.isCollect=res.data;
              })
          },
      }
  }
</script>

<style lang="scss">
  .desc{
    img{width: 100%;}
  }
</style>
<style lang="scss" scoped>
  @import '../../assets/css/common';

  .main-wrap{
    overflow: hidden;}
  .celebrity-detail{
    .info-card{
      background-color:#ffffff;
      border:1px solid #EEEEEE;
      padding:30px 20px;
      width:780px;
      overflow: hidden;
      .photo{
        text-align: center;
        float: left;
        .img{
          width:110px;
          height:110px;
          -webkit-border-radius: 50%;
          -moz-border-radius: 50%;
          border-radius: 50%;
          background-color:$main-color;
        }
        .follow{
          padding-top:10px;
          font-size:16px;
          color:#999999;
          cursor: pointer;
          .icon{
            display: inline-block;
            width:20px;
            height:20px;
            vertical-align: middle;
            margin-left:8px;
          }
        }
      }
      .add-wx{
        width:128px;
        height:56px;
        border:1px solid $main-color;
        margin-top:10px;
        text-align: center;
        font-weight:600;
        font-size:18px;
        color:$main-color;
        -webkit-border-radius: 14px;
        -moz-border-radius: 14px;
        border-radius: 14px;
        i{font-size:25px;
          vertical-align: middle;}
        .tips{font-size:14px;
          font-weight:500;}
      }
      .card-info{
        padding-left:20px;
        float: left;
        width:600px;
        .name{font-size:28px;color:#000000;padding:10px 0 10px;
          float: left;}
        .desc,.honor{
          font-size:16px;color:#333333;
        }
        .desc{
          padding-top:30px;
          line-height: 30px;
        }

      }
      .num-list{
        float: right;
        color:#333333;
        height:32px;
        display: table;
        li{
          display: table-cell;
          vertical-align: middle;
          font-size:14px;
          text-align: center;

          &+li{
            border-left:1px solid #E0DDDD;

          }
          &:first-child{padding-right:20px;}
          &:last-child{padding-left:20px;}
          .num{
            font-size:24px;
          }
          .tit{
            font-size:16px;
            color:#999999;
            padding-top:8px;
          }
        }

      }
    }
  }
  .celebrity-tab{background-color:#ffffff;width:779px;margin-top:10px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;}
  .shop-info{
    background-color:#ffffff;
    /*width:299px;
    height:187px;*/
    padding:30px 55px;
    width:407px;
    .info-top{
      white-space:nowrap;
      .img{
        width:100px;height:100px;
        line-height:100px;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;}
      .desc{vertical-align: top;
        padding-left:29px;
        line-height:42px;
        display: inline-block;font-size:20px;color:#565656;
        .name{font-size:28px;color:#333333;
          font-weight:600;}
      }
    }
    .btn-shop{
      margin-top:31px;
      background-color:$main-color;
      color:#ffffff;
      width:131px;
      height:38px;
      font-size:18px;
      -webkit-border-radius: 18.97px;
      -moz-border-radius: 18.97px;
      border-radius: 18.97px;
    }
  }
  .part{
    border:1px solid #EEEEEE;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
    background-color:#ffffff;}
  .part.celebrity{
    width:409px;
    .title{font-size:22px;
      font-weight:600;color:#333333;border-bottom:1px solid #EEEEEE;padding:30px 18px;}
    .desc{
      margin:30px 20px 40px;
      line-height:20px;color:#333333;font-size:14px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      line-clamp: 4;
      -webkit-box-orient: vertical;
    }
  }
</style>
<style lang="scss">
  @import '../../assets/css/common';
  .celebrity-tab .el-tabs__nav-scroll{padding:20px 0  0 20px;}
  .celebrity-tab .el-tabs__item{color:#333333;font-size:18px;height:50px;padding-left:20px;}
  .celebrity-tab .el-tabs__active-bar{background-color:$main-color;}
  .celebrity-tab .el-tabs__item:hover{color:$main-color;}
</style>
